import styled from 'styled-components';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  border-radius: 6px;
  box-shadow:
    0 2px 3px 0 rgba(8, 10, 37, 0.03),
    0 4px 8.5px 0 rgba(8, 10, 37, 0.05),
    0 7.5px 35px 0 rgba(89, 126, 247, 0.03);
  background-color: #ffffff;
  font-family: 'Nunito Sans', sans-serif;
`;

export const Address = styled.div`
  display: flex;
  width: 264px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: rgba(0, 0, 0, 0.85);
  margin: 22px 22px 0;
  padding: 0;
  gap: 10px;
  justify-content: space-between;
`;

export const PropertyType = styled.div`
  display: flex;
  width: 264px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: rgba(0, 0, 0, 0.85);
  margin: 0 22px;
  padding: 0;
  gap: 10px;
  justify-content: space-between;
`;

export const Body = styled.div`
  margin: 0 22px 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
  height: 100px;
`;

export const Footer = styled.div`
  margin: 16px 22px 0px 22px;
  padding: 0;
  display: flex;
  height: 16px;
  align-items: center;
`;

export const MORE_DETAILS = styled.div`
  height: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 1px;
  color: #37a3bc;
`;

export const Spacer = styled.div`
  height: 100%;
  flex-grow: 1;
`;

export const IconSizer = styled.div`
  width: 16px;
  height: 16px;
`;

export const FooterIconSizer = styled(IconSizer)`
  margin-left: 22px;
  cursor: pointer;
`;

export const LazyImg = styled.img.attrs({
  loading: 'lazy',
})`
  width: auto;
  height: 100px !important;
  max-height: 100px !important;
  border-radius: 4px;
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  height: 100px;
  width: 120px;
`;

export const SummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 120px;
  height: 33px;
  border-width: 1px;
  border-style: none none dashed none;
  border-color: rgba(14, 26, 64, 0.3);
`;

export const Violations = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 120px;
  height: 33px;
`;

const BaseItem = styled.div`
  display: flex;
  align-items: center;
  margin-top: 7px;
  margin-bottom: 9px;
`;

export const SummaryItemLabel = styled(BaseItem)`
  justify-content: flex-start;
  height: 16px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: rgba(14, 26, 64, 0.45);
`;

export const SummaryItemValue = styled(BaseItem)`
  justify-content: flex-end;
`;

export const RoomValue = styled(BaseItem)`
  justify-content: space-between;
  margin: 0;
`;

export const RoomIconSizer = styled(IconSizer)`
  margin-left: 4px;
`;

export const RoomCount = styled.div`
  display: flex;
  align-items: center;
  height: 16px;
  margin-left: ${(props) => props.ml || 0};
`;
